export default function (Site, $) {
  Site.widget('date-selection', {
    _create () {
      this.dateSelection()
    },
    dateSelection () {
      $('#_pickup_location_field input').click(e => {
        if ($(e.target).val() === 'Belconnen Fresh Food Markets') {
          $('#_pickup_date_field').removeClass('no-wednesday')
        } else if ($(e.target).val() === 'Fyshwick Fresh Food Markets') {
          $('#_pickup_date_field').addClass('no-wednesday')
          $("#_pickup_date_field input[value^='Wed']").prop('checked', false)
        }
      })
    }
  })
}
